import { render, staticRenderFns } from "./ChildrenRiderWidget.vue?vue&type=template&id=08a32593&scoped=true"
import script from "./ChildrenRiderWidget.vue?vue&type=script&lang=js"
export * from "./ChildrenRiderWidget.vue?vue&type=script&lang=js"
import style0 from "./ChildrenRiderWidget.vue?vue&type=style&index=0&id=08a32593&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a32593",
  null
  
)

export default component.exports